import styled from "styled-components";

type HeightProps = {
  height: number;
};

type SidebarProps = {
  $isSidebarCollapsed?: boolean;
};

export const DashboardContainer = styled.div<SidebarProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.md};

  @media (max-width: 678px) {
    padding: ${({ theme, $isSidebarCollapsed }) =>
      $isSidebarCollapsed
        ? theme.spacing.md
        : `${theme.spacing.xs} ${theme.spacing.sm}`};
    gap: ${({ theme }) => theme.spacing.md};
    overflow-x: hidden;
    min-width: ${({ $isSidebarCollapsed }) =>
      $isSidebarCollapsed ? "auto" : "295px !important"};
    overflow-x: ${({ $isSidebarCollapsed }) =>
      $isSidebarCollapsed ? "hidden" : "auto"};
  }

  @media (max-width: 375px) {
    padding: ${({ theme, $isSidebarCollapsed }) =>
      $isSidebarCollapsed
        ? `${theme.spacing.xs} ${theme.spacing.sm}`
        : `${theme.spacing.xs} ${theme.spacing.xs}`};
    gap: ${({ theme }) => theme.spacing.sm};
  }
`;

export const VoucherContainer = styled.div<SidebarProps>`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md};
`;

export const StoreInfoCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  width: 340px;
  height: 105px;
  padding: ${({ theme }) => theme.spacing.md};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  box-sizing: border-box;

  @media (max-width: 678px) {
    width: 100%;
    height: auto;
    flex-direction: column;
    align-items: flex-start;
  }

  @media (max-width: 375px) {
    padding: ${({ theme }) => theme.spacing.sm};
    border-radius: 8px;
    gap: ${({ theme }) => theme.spacing.xs};
    min-width: ${({ theme }) => "260px"};
  }
`;

export const StoreInfoContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};

  @media (max-width: 667px) {
    width: 100%;
  }
`;

export const StoreIcon = styled.div<SidebarProps>`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.lightGray};
  border: ${({ theme }) => "1px solid " + theme.colors.lightGray};

  @media (max-width: 678px) {
    display: none;
  }
`;

export const StoreImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StoreDetails = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 375px) {
    gap: ${({ theme }) => theme.spacing.xs};
  }
`;

export const HawkerName = styled.div`
  display: block;
  width: 155px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 8px;
  text-align: left;

  @media (max-width: 678px) {
    width: 215px;
    margin-right: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 8px;
    text-align: left;
  }
`;

export const StoreName = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: 600;
  margin: 0;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  display: flex;
  align-items: center;
  @media (max-width: 678px) {
    font-size: ${({ theme }) => theme.fontSizes.large};
    flex-direction: column;
  }
`;

export const StoreAddress = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.darkGray};
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};

  @media (max-width: 375px) {
    font-size: 12px;
  }
`;

export const DropdownWrapper = styled.div`
  text-align: left;
`;

export const DropdownIcon = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  margin-left: 8px;
`;

export const OverviewSection = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.lg};
  margin-top: ${({ theme }) => theme.spacing.lg};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
  }
`;

export const OverviewIcon = styled.div`
  width: 116px;
  height: 116px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 80px;
    height: 80px;
  }
`;

export const OverviewContent = styled.div`
  flex: 1;
`;

export const OverviewTitle = styled.h3`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  margin: 0 0 ${({ theme }) => theme.spacing.md} 0;
  color: ${({ theme }) => theme.colors.darkGray};
  text-transform: uppercase;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${({ theme }) => theme.spacing.lg};
  width: 100%;

  @media (max-width: 375px) {
    min-width: 260px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StatLabel = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.darkGraylight};
  text-transform: uppercase;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const StatValue = styled.div<{ color?: string }>`
  font-size: ${({ theme }) => theme.fontSizes.xxxxlarge};
  font-weight: 600;
  color: ${({ color, theme }) => color || theme.colors.secondaryText};
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.shadows.small};
  padding: ${({ theme }) => theme.spacing.lg};
  margin-top: ${({ theme }) => theme.spacing.lg};
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 678px) {
    padding: ${({ theme }) => theme.spacing.md};
  }

  @media (max-width: 375px) {
    padding: ${({ theme }) => theme.spacing.sm};
    min-width: 260px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.md};

  @media (max-width: 667px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const CardTitle = styled.h3`
  font-size: ${({ theme }) => theme.fontSizes.xxlarge};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  margin: 0;
  color: ${({ theme }) => theme.colors.darkGray};
`;

export const FilterDropdown = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.xs};
  padding: 10px 16px;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  width: 175px;
  font-size: 14px;
  color: #333333;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  font-weight: 500;
  height: 50px;
  margin-left: 8px;

  @media (max-width: 678px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const ChartContainer = styled.div`
  height: 300px;
  position: relative;
`;

export const ChartBars = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 250px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 667px) {
    gap: 8px;
    padding: 0 10px;
  }

  @media (max-width: 375px) {
    height: 220px;
    gap: 4px;
    padding: 0 5px;
  }
`;

export const ChartBar = styled.div<HeightProps>`
  width: 20px;
  height: ${({ height }) => `${height}%`};
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius.small};

  @media (max-width: 667px) {
    width: 12px;
  }

  @media (max-width: 375px) {
    width: 8px;
  }
`;

export const ChartLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.spacing.sm};
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 667px) {
    padding: 0 10px;
    gap: 8px;
  }

  @media (max-width: 375px) {
    padding: 0 5px;
    gap: 4px;
    margin-top: ${({ theme }) => theme.spacing.xs};
  }
`;

export const ChartLabel = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.darkGray};
  text-align: center;
  width: 20px;

  @media (max-width: 667px) {
    width: 12px;
    font-size: 10px;
  }

  @media (max-width: 375px) {
    width: 8px;
    font-size: 8px;
  }
`;

export const ChartTooltip = styled.div`
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: white;
  padding: ${({ theme }) => theme.spacing.sm};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.fontSizes.small};
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10;

  &:after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #333;
  }
`;

export const StatsCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: ${({ theme }) => theme.spacing.lg};
  margin-top: ${({ theme }) => theme.spacing.lg};
  width: 100%;
  overflow-x: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

export const StatsCard = styled.div`
  background-color: ${({ theme }) => theme.colors.lightGray};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing.md};
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: 6px;
`;

export const StatsCardHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const StatsCardIcon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const StatsCardIconFeedback = styled.div`
  height: 32px;
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const StatsCardTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.lightGrayTitle};
  text-transform: uppercase;
`;

export const StatsCardValue = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xlarge};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkGray};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const StatsCardSubvalue = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.darkGray};
  display: flex;
  align-items: center;
`;

export const StatsCardSubvalueBold = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xlarge};
  color: ${({ theme }) => theme.colors.darkGray};
`;

export const OrdersSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing.lg};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing.md};
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media (max-width: 1279px) and (min-width: 679px) {
    min-width: 350px;
    padding: ${({ theme }) => theme.spacing.md};
  }

  @media (max-width: 678px) and (min-width: 376px) {
    min-width: 272px;
    padding: ${({ theme }) => theme.spacing.sm};
  }

  @media (max-width: 375px) {
    min-width: 260px;
    padding: ${({ theme }) => theme.spacing.sm};
  }
`;

export const OrdersHeader = styled.div`
  width: 100%;
  padding-left: 16px;
  padding-right: 16px;

  @media (min-width: 1281px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media (max-width: 1280px) {
    width: 100%;
  }
`;

export const OrdersTitle = styled.h3`
  font-size: ${({ theme }) => theme.fontSizes.xxlarge};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.darkGray};

  @media (min-width: 1281px) {
    margin: 0;
  }

  @media (max-width: 1280px) {
    margin-bottom: ${({ theme }) => theme.spacing.sm};
  }
`;

export const OrdersFilters = styled.div`
  @media (min-width: 679px) {
    display: flex;
  }
  @media (max-width: 678px) {
    width: 100%;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 228px;

  @media (max-width: 678px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const SearchInput = styled.input`
  padding: ${({ theme }) => `${theme.spacing.xs} ${theme.spacing.sm}`};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.small};
  width: 228px;
  height: 50px;
  padding-left: 40px; /* Make room for the search icon on the left */

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: 678px) {
    width: 100%;
    margin-bottom: 8px;
    margin-top: 8px;
  }
`;

export const OrdersTable = styled.table`
  border-collapse: collapse;
  margin: 8px;
  width: 100%;
  table-layout: auto;

  @media (min-width: 1280px) {
    width: 100%;
    table-layout: fixed;
  }

  @media (max-width: 1279px) and (min-width: 679px) {
    min-width: 600px;
    width: 100%;
  }

  @media (max-width: 678px) and (min-width: 376px) {
    min-width: 272px;
    width: 100%;
  }

  @media (max-width: 375px) {
    min-width: 272px;
    width: 100%;
  }

  th,
  td {
    padding: ${({ theme }) => theme.spacing.md};
    text-align: left;
    white-space: nowrap;

    @media (max-width: 1279px) and (min-width: 679px) {
      padding: ${({ theme }) => theme.spacing.sm};
    }

    @media (max-width: 678px) {
      padding: ${({ theme }) => theme.spacing.sm};
      ${({ theme }) => theme.spacing.xs};
      font-size: ${({ theme }) => theme.fontSizes.small};
      margin-right: 8px;
    }
  }

  tr {
    height: 48px;

    @media (max-width: 678px) {
      height: 40px;
    }
  }

  th {
    font-size: 16px;
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    color: ${({ theme }) => theme.colors.tableHeaderColor};
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray};

    @media (max-width: 678px) {
      font-size: 14px;
      margin-right: 8px;
    }
  }

  td:nth-child(1) {
    font-size: 16px;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    color: #000000;

    @media (max-width: 678px) {
      font-size: 14px;
    }
  }

  tr:not(:last-child) td {
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  }

  tbody tr:hover {
    background-color: ${({ theme }) => theme.colors.background};
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-bottom: ${({ theme }) => theme.spacing.md};

  @media (min-width: 1280px) {
    overflow-x: hidden;
  }

  @media (max-width: 1279px) and (min-width: 376px) {
    min-width: 350px;
  }
`;

export const CheckboxCell = styled.td`
  width: 24px;
`;

export const NoDataFoundText = styled.div`
  padding: 16px;
  height: 50px;
  text-align: center;
  width: 100%;
`;

export const Checkbox = styled.input.attrs({ type: "checkbox" })`
  cursor: pointer;
  margin: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  border-radius: 3px;
  outline: none;
  transition: all 0.2s ease;
  position: relative;
  display: inline-block;
  vertical-align: middle;

  &:checked {
    background-color: ${({ theme }) => theme.colors.secondary};
    border-color: ${({ theme }) => theme.colors.secondary};
  }

  &:checked::before {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 6px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.secondaryDark};
  }
`;

// Mobile Dashboard Styled Components
export const MobileDashboardContainer = styled.div<SidebarProps>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  min-width: ${({ $isSidebarCollapsed }) =>
    $isSidebarCollapsed ? "auto" : "295px"};
  overflow-x: ${({ $isSidebarCollapsed }) =>
    $isSidebarCollapsed ? "hidden" : "auto"};
`;

export const MobileTodaySalesCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
`;

export const MobileTodaySalesTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: #666666;
  margin: 0 0 8px 0;
  text-transform: none;
`;

export const MobileTodaySalesAmount = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #76B041;
  margin-bottom: 16px;
`;

export const MobileTodayStatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
`;

export const MobileTodayStatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MobileTodayStatLabel = styled.div`
  font-size: 12px;
  color: #666666;
  margin-bottom: 4px;
  text-align: center;
`;

export const MobileTodayStatValue = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #76B041;
`;

export const MobileStatisticSection = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
`;

export const MobileStatisticHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const MobileStatisticTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  margin: 0;
`;

export const MobileToggleContainer = styled.div`
  display: flex;
  background-color: #F5F5F5;
  border-radius: 20px;
  padding: 2px;
  gap: 2px;
`;

export const MobileToggleButton = styled.button<{ $active: boolean }>`
  background-color: ${({ $active }) => ($active ? "#E39435" : "transparent")};
  color: ${({ $active }) => ($active ? "white" : "#666666")};
  border: none;
  border-radius: 18px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
`;

export const MobileChartContainer = styled.div`
  width: 100%;
  height: 200px;
  position: relative;
  margin-bottom: 20px;
`;

export const MobileChartTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #E39435;
  margin-bottom: 12px;
`;

export const MobileChartBars = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 140px;
  padding: 0 8px;
`;

export const MobileChartBar = styled.div<{ height: number; $isHighlighted?: boolean }>`
  width: 24px;
  height: ${({ height }) => `${height}px`};
  background-color: ${({ $isHighlighted }) => ($isHighlighted ? "#E39435" : "#E39435")};
  border-radius: 4px 4px 0 0;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export const MobileChartValue = styled.div<{ $isHighlighted?: boolean }>`
  position: absolute;
  top: -25px;
  background-color: ${({ $isHighlighted }) => ($isHighlighted ? "white" : "transparent")};
  color: ${({ $isHighlighted }) => ($isHighlighted ? "#333" : "transparent")};
  padding: ${({ $isHighlighted }) => ($isHighlighted ? "4px 8px" : "0")};
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  box-shadow: ${({ $isHighlighted }) => ($isHighlighted ? "0 2px 4px rgba(0,0,0,0.1)" : "none")};
  white-space: nowrap;
`;

export const MobileChartLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  padding: 0 8px;
`;

export const MobileChartLabel = styled.div`
  font-size: 12px;
  color: #666666;
  text-align: center;
  width: 24px;
`;

export const MobileSummaryCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  width: 100%;
`;

export const MobileSummaryCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 80px;
  justify-content: center;
`;

export const MobileSummaryCardIcon = styled.div`
  width: 24px;
  height: 24px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MobileSummaryCardTitle = styled.div`
  font-size: 12px;
  color: #666666;
  margin-bottom: 4px;
  font-weight: 500;
`;

export const MobileSummaryCardValue = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333333;
`;

// Mock data
export const mockData = {
  storeLocations: [
    {
      hawkerName: "Clementi 448 Market & Food Centre",
      storeName: "Kedai Kopi",
      unitNumber: "Stall #01-19",
    },
    {
      hawkerName: "Old Airport Road Hawker Centre",
      storeName: "Coffee Shop",
      unitNumber: "Stall #02-34",
    },
  ],
  statistic: {
    period: "May 2025",
    growth: "+24.11%",
    chartData: [70, 65, 60, 30, 45, 55, 50, 45, 50, 45, 50, 25],
  },
};

// Dropdown menu components
export const DropdownMenu = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  min-width: 200px;
  display: ${({ $isOpen }) => ($isOpen ? "block" : "none")};
  margin-top: ${({ theme }) => theme.spacing.xs};
  overflow: hidden;
`;

export const DropdownItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGray};
  }

  &:not(:last-child) {
    border-bottom: 1px solid #eeeeee;
  }
`;

export const StoreLocationDropdown = styled(DropdownMenu)`
  width: 100%;
  max-width: 300px;
`;

export const PeriodDropdown = styled(DropdownMenu)`
  width: 150px;
`;

export const PeriodToggleContainer = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.lightGray};
  width: 180px;
  height: 40px;
  overflow: hidden;
  margin-left: 20px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.secondary};

  @media (max-width: 667px) {
    margin-left: 0;
    margin-top: 10px;
    margin-bottom: 15px;
  }
`;

export const PeriodToggleButton = styled.button<{ $active: boolean }>`
  flex: 1;
  background-color: ${({ $active, theme }) => ($active ? theme.colors.secondary : "transparent")};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.background : theme.colors.darkGray};
  font-weight: ${({ $active }) => ($active ? "600" : "400")};
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  padding: 0;
  outline: none;
  border: none;
  border-right: ${({ $active, theme }) =>
    !$active ? `1px solid ${theme.colors.secondary}` : "none"};

  &:last-child {
    border-right: none;
  }
`;

// Pagination styled components
export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  overflow-x: auto;

  @media (max-width: 1279px) and (min-width: 376px) {
    padding: ${({ theme }) => theme.spacing.sm} 0;
  }
`;

export const PaginationList = styled.ul`
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const PaginationItem = styled.li<{ $selected?: boolean }>`
  width: 36px;
  height: 36px;
  border-radius: 5px;
  background: ${({ $selected, theme }) =>
    $selected ? theme.colors.darkGray : theme.colors.background};
  color: ${({ $selected, theme }) =>
    $selected ? theme.colors.background : theme.colors.primary};
  margin: 0 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid
    ${({ $selected, theme }) =>
      $selected ? theme.colors.darkGray : theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: ${({ theme }) => theme.fontWeights.bold};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.background};
    border: 1px solid ${({ theme }) => theme.colors.background};
  }

  &.dots {
    border: none;
    &:hover {
      background-color: transparent;
      color: inherit;
      cursor: default;
    }
  }
`;

export const PaginationArrow = styled.li<{ $disabled?: boolean }>`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? "0.5" : "1")};
  margin: 0 3px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;

  &:hover {
    opacity: ${({ $disabled }) => ($disabled ? "0.5" : "0.8")};
  }
`;

// Mobile Pagination Styles
export const MobilePaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.sm} 0;

  /* Only show on mobile screens */
  @media (min-width: 376px) {
    display: none;
  }
`;

export const MobilePaginationList = styled.ul`
  display: flex;
  align-items: center;
  list-style-type: none;
  padding: 0;
  margin: 0;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const MobilePaginationArrow = styled.li<{ $disabled?: boolean }>`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? "0.4" : "1")};
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.background};
  border-radius: 4px;
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  transition: all 0.2s ease;

  &:hover {
    opacity: ${({ $disabled }) => ($disabled ? "0.4" : "0.8")};
    transform: ${({ $disabled }) => ($disabled ? "none" : "scale(1.05)")};
  }

  span {
    font-size: 12px;
    line-height: 1;
  }
`;

export const MobilePaginationInfo = styled.li`
  padding: 0 ${({ theme }) => theme.spacing.sm};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.primary};
  white-space: nowrap;
  min-width: 60px;
  text-align: center;
`;

// Responsive Pagination Container
export const ResponsivePaginationContainer = styled.div`
  width: 100%;
  text-align: center;
`;

// Desktop/Tablet Pagination Wrapper
export const DesktopTabletPaginationWrapper = styled.div`
  display: block;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

// Mobile Pagination Wrapper
export const MobilePaginationWrapper2 = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    width:100%;
  }
`;
